import { IsNumber, IsString, Min, IsDefined } from 'class-validator';
import { RgbaDto } from './RgbaDto';
import { GradientDto } from './GradientDto';
import { IsColorOrReference } from './validators/IsColorOrReference';

export class BodySizeDto {
  @IsDefined()
  @IsNumber()
  @Min(0)
  fontSize!: number;

  @IsDefined()
  @IsColorOrReference()
  fontColor!: RgbaDto | GradientDto | string;

  @IsDefined()
  @IsNumber()
  letterSpacing!: number;

  @IsDefined()
  @IsString()
  fontWeight!: string;

  @IsDefined()
  @IsNumber()
  lineHeight!: number;

  @IsColorOrReference()
  backgroundColor!: RgbaDto | GradientDto | string | null;
}
